import React from 'react';
import { Card, CardContent, CardActions, Skeleton, Box } from '@mui/material';

/**
 * Skeleton component that matches the structure of PersonaCard for better loading UX
 */
export const PersonaCardSkeleton: React.FC = () => (
  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    <CardContent sx={{ flexGrow: 1 }}>
      {/* Avatar and name section */}
      <Box display="flex" alignItems="center" mb={2}>
        <Skeleton variant="circular" width={48} height={48} sx={{ mr: 2 }} />
        <Box flex={1}>
          <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="50%" height={16} />
        </Box>
      </Box>
      
      {/* Description */}
      <Box sx={{ mb: 2, minHeight: '2.5em' }}>
        <Skeleton variant="text" width="100%" height={16} />
        <Skeleton variant="text" width="80%" height={16} />
      </Box>
      
      {/* Usage chip */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 3 }} />
      </Box>
    </CardContent>

    {/* Card actions */}
    <CardActions sx={{ justifyContent: 'flex-end', pt: 0 }}>
      <Skeleton variant="circular" width={32} height={32} sx={{ mr: 1 }} />
      <Skeleton variant="circular" width={32} height={32} />
    </CardActions>
  </Card>
);

export default PersonaCardSkeleton;